import { Component, OnDestroy } from '@angular/core';
import { PrimengTranslateService } from '@sharedcommon/services/primeng-translate.service';
import { Constants } from '@sharedcommon/util/constants.util';
import { SampleAdvancedSearchService } from '@usercommon/service/sample-advanced-search.service';

@Component({
  selector: 'neq-page',
  templateUrl: './neq.page.html'
})
export class NeqPage implements OnDestroy {

  isIE = Constants.IS_INTERNET_EXPLORER;

  constructor(
    private readonly primengTranslateService: PrimengTranslateService,
    private readonly advancedSearchService: SampleAdvancedSearchService
  ) {
    this.primengTranslateService.applyCalendarLanguage();
  }

  ngOnDestroy(): void {
    this.advancedSearchService.resetAdvancedSearch();
  }
}
